import React, { useEffect, useRef, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import {
  FiArrowRight, FiAward, FiChevronLeft, FiChevronRight,
  FiPhone, FiCheckCircle, FiPlus, FiMinus, FiX,
  FiPackage,
} from "react-icons/fi";
import { useInView } from "../components/useInView";

/* ── hero right-column images ── */
import heroImg1 from "../assets/uploads/company/illustration-8.png";
import heroImg2 from "../assets/uploads/company/illustration-9.jpg";

/* ── quick-fix icons ── */
import qf1 from "../assets/uploads/services/quick-fix-1.svg";
import qf2 from "../assets/uploads/services/quick-fix-2.svg";
import qf3 from "../assets/uploads/services/quick-fix-3.svg";
import qf4 from "../assets/uploads/services/quick-fix-4.svg";
import qf5 from "../assets/uploads/services/quick-fix-5.svg";
import qf6 from "../assets/uploads/services/quick-fix-6.svg";

/* ── before / after comparison images ── */
import beforeImg from "../assets/uploads/gallery/1771749618732-112878534.jpg";
import afterImg  from "../assets/uploads/gallery/1771749632555-479601276.jpg";

/* ── "We Give the Best Services" section assets ── */
import carSvg    from "../assets/uploads/about/car.svg";
import repairSvg from "../assets/uploads/about/repair.svg";
import aboutHero from "../assets/uploads/about/1771700776853-9752745312.webp";

const quickFixIcons = [qf1, qf2, qf3, qf4, qf5, qf6];

import svcStatIcon1 from "../assets/uploads/services/service_01.svg";
import svcStatIcon2 from "../assets/uploads/services/service_02.svg";
import svcStatIcon3 from "../assets/uploads/services/service_03.svg";
import svcStatIcon4 from "../assets/uploads/services/service_04.svg";

/* ── product tab SVG icons (What We Stock section) ── */
import prodIcon1   from "../assets/uploads/products/brake.svg";
import prodIcon2   from "../assets/uploads/products/battery.svg";
import prodIcon3   from "../assets/uploads/products/engine.svg";
import prodIcon4   from "../assets/uploads/products/windshield.svg";
import prodIcon5   from "../assets/uploads/products/disc.svg";
import productsCar from "../assets/uploads/products/products-tab.png";

/* ── slider icons ── */
import sliderIcon1 from "../assets/uploads/about/slider_icon_01.png";
import sliderIcon2 from "../assets/uploads/about/slider_icon_02.png";
import sliderIcon3 from "../assets/uploads/about/slider_icon_03.png";
import sliderIcon4 from "../assets/uploads/about/slider_icon_04.png";
import sliderIcon5 from "../assets/uploads/about/slider_icon_05.png";

import logoFord       from "../assets/uploads/cars/ford.svg";
import logoVolkswagen from "../assets/uploads/cars/volkswagen.svg";
import logoAudi       from "../assets/uploads/cars/audi.svg";
import logoSuzuki     from "../assets/uploads/cars/suzuki.svg";
import logoHyundai    from "../assets/uploads/cars/hyundai.svg";
import logoHonda      from "../assets/uploads/cars/honda.svg";
import logoBMW        from "../assets/uploads/cars/bmw.svg";
import logoKia        from "../assets/uploads/cars/kia.svg";
import logoMercedes   from "../assets/uploads/cars/mercedes.svg";
import logoToyota     from "../assets/uploads/cars/toyota.svg";
import logoNissan     from "../assets/uploads/cars/nissan.svg";
import logoMazda      from "../assets/uploads/cars/mazda.svg";

import logoPngFord       from "../assets/uploads/cars/ford.png";
import logoPngVolkswagen from "../assets/uploads/cars/volkswagen.png";
import logoPngAudi       from "../assets/uploads/cars/audi.png";
import logoPngSuzuki     from "../assets/uploads/cars/suzuki.png";
import logoPngHyundai    from "../assets/uploads/cars/hyundai.png";
import logoPngHonda      from "../assets/uploads/cars/honda.png";
import logoPngBMW        from "../assets/uploads/cars/bmw.png";
import logoPngKia        from "../assets/uploads/cars/kia.png";
import logoPngMercedes   from "../assets/uploads/cars/mercedes1.png";
import logoPngToyota     from "../assets/uploads/cars/toyota1.png";
import logoPngNissan     from "../assets/uploads/cars/nissan.png";
import logoPngMazda      from "../assets/uploads/cars/mazda.png";
import logoPngCherry    from "../assets/uploads/cars/cherry.png";
import logoPngChevrolet from "../assets/uploads/cars/chevrolet.png";
import logoPngGwm       from "../assets/uploads/cars/gwm.png";
import logoPngJeep      from "../assets/uploads/cars/jeep.png";

function galleryImg(filename) {
  if (!filename) return null;
  return `${process.env.REACT_APP_API_URL}/uploads/gallery/${filename}`;
}

const SLIDER_ICONS = [
  { src: sliderIcon1, label: "Coffee While You Wait" },
  { src: sliderIcon2, label: "Carwash After Service" },
  { src: sliderIcon3, label: "Emergency Calls" },
  { src: sliderIcon4, label: "Friendly Customer Service" },
  { src: sliderIcon5, label: "24/7 Services" },
];

/* ── shop images (webpack require.context) ── */
function shopImg(filename) {
  if (!filename) return null;
  return `${process.env.REACT_APP_API_URL}/uploads/shop/${filename}`;
}

import "./Home.css";

/* ─────────────────────────────────────
   Module-level constants
   ───────────────────────────────────── */

const SLIDE_IMG_BASE = `${process.env.REACT_APP_API_URL}/uploads/slideshow/`;

const MINI_STATS = [
  { icon: svcStatIcon1, text: "Engine Repairs", to: "/services" },
  { icon: svcStatIcon2, text: "Diagnostics",    to: "/services" },
  { icon: svcStatIcon3, text: "Brake Services", to: "/services" },
  { icon: svcStatIcon4, text: "Oil & Servicing",to: "/services" },
];

const CAR_BRAND_LOGOS = [
  { name: "Ford",       src: logoFord       },
  { name: "Volkswagen", src: logoVolkswagen },
  { name: "Audi",       src: logoAudi       },
  { name: "Suzuki",     src: logoSuzuki     },
  { name: "Hyundai",    src: logoHyundai    },
  { name: "Honda",      src: logoHonda      },
  { name: "BMW",        src: logoBMW        },
  { name: "Kia",        src: logoKia        },
  { name: "Mercedes",   src: logoMercedes   },
  { name: "Toyota",     src: logoToyota     },
  { name: "Nissan",     src: logoNissan     },
  { name: "Mazda",      src: logoMazda      },
];

const CAR_BRAND_PNG_LOGOS = [
  { name: "Audi",       src: logoPngAudi       },
  { name: "BMW",        src: logoPngBMW        },
  { name: "Chery",      src: logoPngCherry     },
  { name: "Chevrolet",  src: logoPngChevrolet  },
  { name: "Ford",       src: logoPngFord       },
  { name: "GWM",        src: logoPngGwm        },
  { name: "Honda",      src: logoPngHonda      },
  { name: "Hyundai",    src: logoPngHyundai    },
  { name: "Jeep",       src: logoPngJeep       },
  { name: "Kia",        src: logoPngKia        },
  { name: "Mazda",      src: logoPngMazda      },
  { name: "Mercedes",   src: logoPngMercedes   },
  { name: "Nissan",     src: logoPngNissan     },
  { name: "Suzuki",     src: logoPngSuzuki     },
  { name: "Toyota",     src: logoPngToyota     },
  { name: "Volkswagen", src: logoPngVolkswagen },
];

const PROD_ICONS = [prodIcon1, prodIcon2, prodIcon3, prodIcon4, prodIcon5];

const CAR_BADGES = [
  { cls: "products-panel__badge--tl", iconIdx: 3, label: "Engine"  },
  { cls: "products-panel__badge--tr", iconIdx: 0, label: "Brakes"  },
  { cls: "products-panel__badge--ml", iconIdx: 4, label: "Disc"    },
  { cls: "products-panel__badge--mr", iconIdx: 1, label: "Battery" },
  { cls: "products-panel__badge--bl", iconIdx: 2, label: "Glass"   },
];

/* Fallback tab list when API returns < 6 categories */
const FALLBACK_TABS = [
  { key: "all",          label: "All Parts"     },
  { key: "brakes",       label: "Brakes"        },
  { key: "engine",       label: "Engine"        },
  { key: "electrical",   label: "Electrical"    },
  { key: "suspension",   label: "Suspension"    },
  { key: "transmission", label: "Transmission"  },
  { key: "oils",         label: "Oils & Fluids" },
];

/* ─────────────────────────────────────
   Helpers
   ───────────────────────────────────── */

function heroPath(link) {
  if (!link) return "/";
  const map = {
    "index.php":           "/",
    "services.php":        "/services",
    "products.php":        "/products",
    "about-us.php":        "/about-us",
    "portfolio.php":       "/portfolio",
    "contact.php":         "/contact",
    "shop.php":            "/shop",
  };
  if (map[link]) return map[link];
  if (!link.startsWith("/")) return `/${link}`;
  return link;
}

function useNoContextMenu() {
  useEffect(() => {
    const handler = (e) => e.preventDefault();
    document.addEventListener("contextmenu", handler);
    return () => document.removeEventListener("contextmenu", handler);
  }, []);
}

function useBreakpoint() {
  const getBreakpoint = () => {
    if (typeof window === "undefined") return "desktop";
    const w = window.innerWidth;
    if (w <= 768) return "mobile";
    if (w <= 1024) return "tablet";
    return "desktop";
  };
  const [bp, setBp] = useState(getBreakpoint);
  useEffect(() => {
    const handler = () => setBp(getBreakpoint());
    window.addEventListener("resize", handler);
    return () => window.removeEventListener("resize", handler);
  }, []);
  return bp;
}

function VideoModal({ isOpen, onClose }) {
  useEffect(() => {
    document.body.style.overflow = isOpen ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [isOpen]);
  if (!isOpen) return null;
  return (
    <div className="video-modal" onClick={onClose}>
      <div className="video-modal__box" onClick={(e) => e.stopPropagation()}>
        <button className="video-modal__close" onClick={onClose} aria-label="Close video">
          <FiX size={22} />
        </button>
        <div className="video-modal__embed">
          <iframe
            src="https://www.youtube.com/embed/9oVDA83yxWI?autoplay=1"
            title="Video"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div>
      </div>
    </div>
  );
}

function stripHtmlText(html) {
  if (!html) return "";
  const tmp = document.createElement("div");
  tmp.innerHTML = html;
  return (tmp.textContent || tmp.innerText || "").replace(/\s+/g, " ").trim();
}

function wordLimit(text, n) {
  if (!text) return "";
  const words = text.split(" ").filter(Boolean);
  return words.length <= n ? text : words.slice(0, n).join(" ") + "…";
}

function getServiceImg(svc) {
  const f = svc.image1 || svc.image2 || svc.image3 || svc.image4 || svc.image5;
  return f ? `${process.env.REACT_APP_API_URL}/uploads/services/${f}` : null;
}

function resolveServiceImg(svc) {
  if (!svc) return null;
  return getServiceImg(svc);
}

function fmtPrice(n) {
  return "R " + Number(n).toLocaleString("en-ZA", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

/* ═══════════════════════════════════════════════════════════════════
   BEFORE / AFTER SLIDER
   ═══════════════════════════════════════════════════════════════════ */
function BeforeAfterSlider({ beforeSrc, afterSrc }) {
  const [position, setPosition] = useState(50);
  const [dragging, setDragging] = useState(false);
  const containerRef = useRef(null);

  const updatePosition = useCallback((clientX) => {
    if (!containerRef.current) return;
    const rect = containerRef.current.getBoundingClientRect();
    const pct = Math.min(100, Math.max(0, ((clientX - rect.left) / rect.width) * 100));
    setPosition(pct);
  }, []);

  const onMouseDown  = (e) => { e.preventDefault(); setDragging(true); };
  const onMouseMove  = useCallback((e) => { if (dragging) updatePosition(e.clientX); }, [dragging, updatePosition]);
  const onMouseUp    = useCallback(() => setDragging(false), []);
  const onTouchStart = () => setDragging(true);
  const onTouchMove  = useCallback((e) => { if (dragging) updatePosition(e.touches[0].clientX); }, [dragging, updatePosition]);
  const onTouchEnd   = useCallback(() => setDragging(false), []);

  useEffect(() => {
    if (dragging) {
      window.addEventListener("mousemove", onMouseMove);
      window.addEventListener("mouseup",   onMouseUp);
      window.addEventListener("touchmove", onTouchMove);
      window.addEventListener("touchend",  onTouchEnd);
    }
    return () => {
      window.removeEventListener("mousemove", onMouseMove);
      window.removeEventListener("mouseup",   onMouseUp);
      window.removeEventListener("touchmove", onTouchMove);
      window.removeEventListener("touchend",  onTouchEnd);
    };
  }, [dragging, onMouseMove, onMouseUp, onTouchMove, onTouchEnd]);

  return (
    <div ref={containerRef} className="bac__slider" onMouseDown={onMouseDown} onTouchStart={onTouchStart}
      style={{ userSelect: "none", cursor: dragging ? "grabbing" : "grab" }}>
      <div className="bac__img-wrap bac__img-wrap--before">
        <img src={beforeSrc} alt="Before repair" draggable="false" />
        <span className="bac__label bac__label--before">BEFORE</span>
      </div>
      <div className="bac__img-wrap bac__img-wrap--after" style={{ clipPath: `inset(0 0 0 ${position}%)` }}>
        <img src={afterSrc} alt="After repair" draggable="false" />
        <span className="bac__label bac__label--after">AFTER</span>
      </div>
      <div className="bac__divider" style={{ left: `${position}%` }}>
        <div className="bac__handle">
          <FiChevronLeft size={14} /><FiChevronRight size={14} />
        </div>
      </div>
    </div>
  );
}

/* ═══════════════════════════════════════════════════════════════════
   FEATURED PRODUCT CARD
   ═══════════════════════════════════════════════════════════════════ */
function FeaturedProductCard({ product }) {
  const price    = Number(product.sale_price || product.price);
  const oldPrice = product.sale_price ? Number(product.price) : null;
  const imgSrc   = shopImg(product.image1);
  const desc     = wordLimit(stripHtmlText(product.description || ""), 18);

  return (
    <div className="fp-card">
      <div className="fp-card__img-wrap">
        {imgSrc
          ? <img src={imgSrc} alt={product.name} loading="lazy" draggable="false" />
          : <div className="fp-card__no-img"><FiPackage size={40} /></div>
        }
        {product.discount_percent > 0 && (
          <span className="fp-card__discount">-{Math.round(product.discount_percent)}%</span>
        )}
      </div>
      <div className="fp-card__body">
        <h4 className="fp-card__name">{product.name}</h4>
        <div className="fp-card__prices">
          <span className="fp-card__price">{fmtPrice(price)}</span>
          {oldPrice && <span className="fp-card__old">{fmtPrice(oldPrice)}</span>}
        </div>
        {desc && <p className="fp-card__desc">{desc}</p>}
        <Link to={`/shop/${product.slug}`} className="fp-card__btn">
          VIEW PRODUCT
        </Link>
      </div>
    </div>
  );
}

/* ═══════════════════════════════════════════════════════════════════
   HOME COMPONENT
   ═══════════════════════════════════════════════════════════════════ */
export default function Home() {

  useNoContextMenu();
  const breakpoint = useBreakpoint();

  /* ── Slideshow ── */
  const [slides,        setSlides]        = useState([]);
  const [slidesLoading, setSlidesLoading] = useState(true);

  /* ── Services (loaded from API, start empty) ── */
  const [homeServices,   setHomeServices]   = useState([]);
  const [featuredSvcIdx, setFeaturedSvcIdx] = useState(0);

  /* ── Company contact ── */
  const [contact, setContact] = useState(null);

  /* ── About us ── */
  const [aboutUs, setAboutUs] = useState(null);

  /* ── Featured shop products ── */
  const [shopProducts,        setShopProducts]        = useState([]);
  const [shopProductsLoading, setShopProductsLoading] = useState(true);
  const [activeTab,           setActiveTab]           = useState("all");
  const [shopCategories,      setShopCategories]      = useState([]);
  const fpTrackRef = useRef(null);

  /* ── Slideshow navigation ── */
  const [current,   setCurrent]   = useState(0);
  const [prev,      setPrev]      = useState(null);
  const [animating, setAnimating] = useState(false);
  const [direction, setDirection] = useState("next");
  const timerRef = useRef(null);

  /* ── Gallery ── */
  const [galleryImages,  setGalleryImages]  = useState([]);
  const [galleryLoading, setGalleryLoading] = useState(true);
  const [galleryIndex,   setGalleryIndex]   = useState(0);

  /* ── In-view refs ── */
  const [vehiclesRef, vehiclesInView] = useInView();
  const [galleryRef,  galleryInView]  = useInView();
  const [homeSvcSecRef, homeSvcSecInView] = useInView();
  const [bacRef,        bacInView]        = useInView();
  const [prodSecRef,    prodSecInView]    = useInView();
  const [wgbsRef,       wgbsInView]       = useInView();
  const [fpRef,         fpInView]         = useInView();

  /* ── Misc UI ── */
  const [videoOpen,    setVideoOpen]    = useState(false);
  const [svcIndex,     setSvcIndex]     = useState(0);
  const [activeFilter, setActiveFilter] = useState("All");

  /* ── Products (What We Stock) ── */
  const [products,        setProducts]        = useState([]);
  const [productsLoading, setProductsLoading] = useState(true);
  const [activeProduct,   setActiveProduct]   = useState(0);

  /* ── Fetch: slideshow ── */
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/slideshow`)
      .then(r => r.json())
      .then(data => { setSlides(Array.isArray(data) ? data : []); setSlidesLoading(false); })
      .catch(() => setSlidesLoading(false));
  }, []);

  /* ── Fetch: gallery ── */
  useEffect(() => {
    setGalleryLoading(true);
    fetch(`${process.env.REACT_APP_API_URL}/api/gallery`)
      .then(r => r.json())
      .then(data => { setGalleryImages(Array.isArray(data) ? data : []); setGalleryLoading(false); })
      .catch(() => setGalleryLoading(false));
  }, []);

  /* ── Fetch: company contact ── */
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/company-contact`)
      .then(r => r.json())
      .then(data => { if (data?.id) setContact(data); })
      .catch(() => {});
  }, []);

  /* ── Fetch: services ── */
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/services`)
      .then(r => r.json())
      .then(data => {
        if (Array.isArray(data) && data.length > 0) {
          setHomeServices(data);
          setFeaturedSvcIdx(i => Math.min(i, data.length - 1));
        }
      })
      .catch(() => {});
  }, []);

  /* ── Fetch: about us ── */
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/about-us`)
      .then(r => r.json())
      .then(data => { if (data) setAboutUs(data); })
      .catch(() => {});
  }, []);

  /* ── Fetch: shop products ── */
  useEffect(() => {
    setShopProductsLoading(true);
    fetch(`${process.env.REACT_APP_API_URL}/api/shop/products?limit=50&sort=newest`)
      .then(r => r.json())
      .then(data => {
        const prods = data.products || (Array.isArray(data) ? data : []);
        setShopProducts(prods);
        setShopProductsLoading(false);
      })
      .catch(() => setShopProductsLoading(false));
  }, []);

  /* ── Fetch: shop categories ── */
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/shop/categories`)
      .then(r => r.json())
      .then(data => { if (Array.isArray(data)) setShopCategories(data); })
      .catch(() => {});
  }, []);

  /* ── Fetch: products (What We Stock) ── */
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/products`)
      .then(r => r.json())
      .then(data => {
        if (Array.isArray(data) && data.length > 0) setProducts(data);
        setProductsLoading(false);
      })
      .catch(() => setProductsLoading(false));
  }, []);

  /* ── Slideshow navigation ── */
  const goTo = useCallback((idx, dir = "next") => {
    if (animating || idx === current || slides.length === 0) return;
    setDirection(dir); setPrev(current); setAnimating(true); setCurrent(idx);
    setTimeout(() => { setPrev(null); setAnimating(false); }, 900);
  }, [animating, current, slides.length]);

  const next  = useCallback(() => { if (slides.length === 0) return; goTo((current + 1) % slides.length, "next"); }, [current, goTo, slides.length]);
  const prev_ = useCallback(() => { if (slides.length === 0) return; goTo((current - 1 + slides.length) % slides.length, "prev"); }, [current, goTo, slides.length]);

  useEffect(() => {
    if (slides.length === 0) return;
    timerRef.current = setInterval(next, 6000);
    return () => clearInterval(timerRef.current);
  }, [next, slides.length]);

  const resetTimer = () => { clearInterval(timerRef.current); if (slides.length > 0) timerRef.current = setInterval(next, 6000); };
  const handleNext = () => { next(); resetTimer(); };
  const handlePrev = () => { prev_(); resetTimer(); };
  const handleDot  = (i) => { goTo(i, i > current ? "next" : "prev"); resetTimer(); };

  /* ── Services carousel ── */
  const svcVisible  = breakpoint === "mobile" ? 1 : breakpoint === "tablet" ? 2 : 3;
  const svcMaxIndex = homeServices.length - svcVisible;
  useEffect(() => {
    setSvcIndex(i => Math.min(i, homeServices.length - svcVisible));
  }, [svcVisible, homeServices.length]);
  const handleSvcPrev = () => setSvcIndex(i => Math.max(0, i - 1));
  const handleSvcNext = () => setSvcIndex(i => Math.min(svcMaxIndex, i + 1));

  /* ── Derived ── */
  const currentSlide = slides[current] || null;
  const featured     = homeServices.length > 0 ? homeServices[featuredSvcIdx] : null;
  const gridItems    = homeServices.filter((_, i) => i !== featuredSvcIdx).slice(0, 6);
  const phoneNumber  = contact?.phone_number || "";
  const activeProd   = products[activeProduct] || null;

  const GALLERY_VISIBLE = breakpoint === "mobile" ? 1 : breakpoint === "tablet" ? 3 : 5;
  const galleryMaxIndex = Math.max(0, galleryImages.length - GALLERY_VISIBLE);

  const handleGalleryPrev = () => setGalleryIndex(i => Math.max(0, i - 1));
  const handleGalleryNext = () => setGalleryIndex(i => Math.min(galleryMaxIndex, i + 1));

  /* ── WGBS helpers ── */
  const wgbsServices = homeServices.slice(0, 8);
  const wgbsCol1 = wgbsServices.filter((_, i) => i % 2 === 0);
  const wgbsCol2 = wgbsServices.filter((_, i) => i % 2 === 1);
  const aboutDesc = aboutUs?.content
    ? wordLimit(stripHtmlText(aboutUs.content), 55)
    : "We've invested in high-quality diagnostic tools, lifts, and other essential repair equipment — certified mechanics and provide ongoing training to keep up with evolving car technologies.";

  /* ── Build tab list from shop categories ── */
  const dynamicTabs = [
    { key: "all", label: "All Parts" },
    ...shopCategories.slice(0, 6).map(c => ({ key: c.slug, label: c.name, catId: c.id })),
  ];
  const finalTabs = dynamicTabs.length >= 7
    ? dynamicTabs.slice(0, 7)
    : [...dynamicTabs, ...FALLBACK_TABS.slice(dynamicTabs.length)].slice(0, 7);

  /* ── Filter shop products by active tab ── */
  const filteredShopProducts = activeTab === "all"
    ? shopProducts
    : shopProducts.filter(p => {
        const tab = finalTabs.find(t => t.key === activeTab);
        if (tab?.catId) return p.category_id === tab.catId;
        const name = (p.name || "").toLowerCase();
        const cat  = (p.category_name || "").toLowerCase();
        return name.includes(activeTab) || cat.includes(activeTab);
      });

  /* ── Featured products track scroll ── */
  const scrollFpLeft  = () => fpTrackRef.current?.scrollBy({ left: -320, behavior: "smooth" });
  const scrollFpRight = () => fpTrackRef.current?.scrollBy({ left:  320, behavior: "smooth" });

  return (
    <main className="home">

      <VideoModal isOpen={videoOpen} onClose={() => setVideoOpen(false)} />

      {/* ═══════════ HERO ═══════════ */}
      <section className="hero hero--new">
        <div className="hero__left-col">
          {slidesLoading ? (
            <div className="hero__slide-skeleton" />
          ) : slides.length === 0 ? (
            <div className="hero__slide-fallback">
              <div className="slide-bg" style={{ backgroundImage: `url(https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=1600&q=80)` }} />
              <div className="slide-overlay" />
            </div>
          ) : (
            slides.map((slide, i) => {
              const isActive = i === current;
              const isPrev   = i === prev;
              let cls = "hero__slide";
              if (isActive) cls += ` hero__slide--active hero__slide--enter-${direction}`;
              if (isPrev)   cls += ` hero__slide--exit hero__slide--exit-${direction}`;
              return (
                <div key={slide.id} className={cls}>
                  <div className="slide-bg" style={{ backgroundImage: `url(${SLIDE_IMG_BASE}${slide.image_filename})` }} />
                  <div className="slide-overlay" />
                </div>
              );
            })
          )}

          <div className="hero__text-box-wrap">
            {currentSlide && (
              <div className="hero-text-box">
                <div className="hero__eyebrow">
                  <i className="bi bi-stars" style={{ color: "#dc3545", marginRight: 8 }} />
                  <span>{currentSlide.title}</span>
                </div>
                <h1 className="hero__heading">{currentSlide.title}</h1>
                {currentSlide.subtitle && <p className="hero__lead">{currentSlide.subtitle}</p>}
                <div className="hero__actions">
                  {currentSlide.button_text && currentSlide.button_link && (
                    <Link to={heroPath(currentSlide.button_link)} className="btn hero__cta-blue">
                      {currentSlide.button_text}<FiArrowRight style={{ marginLeft: 6 }} />
                    </Link>
                  )}
                  <Link to="/shop" className="hero__shop-btn">SHOP HERE</Link>
                </div>
                <div className="mini-stats">
                  {MINI_STATS.map((s, idx) => (
                    <div key={idx} className="stat">
                      <img src={s.icon} alt={s.text} className="stat-icon" />
                      <Link to={s.to}>{s.text}</Link>
                    </div>
                  ))}
                </div>
                <div className="hero__icon-strip">
                  {SLIDER_ICONS.map((icon, i) => (
                    <div key={i} className="hero__icon-box" title={icon.label} aria-label={icon.label}>
                      <img src={icon.src} alt={icon.label} draggable="false" />
                    </div>
                  ))}
                </div>
              </div>
            )}
            {slidesLoading && (
              <div className="hero-text-box hero-text-box--skeleton">
                <div className="skeleton-line skeleton-line--short" />
                <div className="skeleton-line skeleton-line--long" />
                <div className="skeleton-line skeleton-line--medium" />
              </div>
            )}
          </div>

          {slides.length > 1 && (
            <div className="hero__pagination">
              {slides.map((_, i) => (
                <button key={i} className={`hero__dot${i === current ? " hero__dot--active" : ""}`}
                  onClick={() => handleDot(i)} aria-label={`Slide ${i + 1}`} />
              ))}
            </div>
          )}
        </div>

        <div className="hero__right-col">
          <div className="hero__media-stack">
            <figure className="hero__media hero__media--primary">
              <img src={heroImg1} alt="Noel Automotive" draggable="false" onDragStart={e => e.preventDefault()} onContextMenu={e => e.preventDefault()} />
            </figure>
            <figure className="hero__media hero__media--secondary">
              <img src={heroImg2} alt="Automotive services" draggable="false" onDragStart={e => e.preventDefault()} onContextMenu={e => e.preventDefault()} />
            </figure>
            <div className="hero__floating-badge">
              <FiAward size={16} /><span>NOEL AUTOMOTIVE REPAIRS</span>
            </div>
          </div>
        </div>
      </section>

      {/* ═══════════════════════════════════════
          FEATURED PRODUCTS — below hero
          ═══════════════════════════════════════ */}
      <section className="fp-section" ref={fpRef}>
        <div className="fp-section__tabs-wrap">
          <div className="container">
            <div className="fp-section__tabs">
              {finalTabs.map(tab => (
                <button
                  key={tab.key}
                  className={`fp-section__tab ${activeTab === tab.key ? "fp-section__tab--active" : ""}`}
                  onClick={() => setActiveTab(tab.key)}
                >
                  {tab.label}
                </button>
              ))}
            </div>
          </div>
        </div>

        <div className="fp-section__track-wrap">
          <div className="container fp-section__track-container">
            <button className="fp-section__arrow fp-section__arrow--left" onClick={scrollFpLeft} aria-label="Scroll left">
              <FiChevronLeft size={20} />
            </button>

            {shopProductsLoading ? (
              <div className="fp-section__track" ref={fpTrackRef}>
                {Array.from({ length: 4 }).map((_, i) => (
                  <div key={i} className="fp-card fp-card--skeleton" />
                ))}
              </div>
            ) : filteredShopProducts.length === 0 ? (
              <div className="fp-section__empty">
                <FiPackage size={40} />
                <p>No products in this category yet.</p>
                <Link to="/shop" className="fp-section__empty-link">Browse all products →</Link>
              </div>
            ) : (
              <div className={`fp-section__track fade-in ${fpInView ? "visible" : ""}`} ref={fpTrackRef}>
                {filteredShopProducts.map(product => (
                  <FeaturedProductCard key={product.id} product={product} />
                ))}
              </div>
            )}

            <button className="fp-section__arrow fp-section__arrow--right" onClick={scrollFpRight} aria-label="Scroll right">
              <FiChevronRight size={20} />
            </button>
          </div>
        </div>

        <div className="fp-section__footer">
          <Link to="/shop" className="fp-section__view-all">
            View All Products <FiArrowRight size={14} />
          </Link>
        </div>
      </section>

      {/* ═══════════════════════════════════════
          WE GIVE THE BEST SERVICES
          ═══════════════════════════════════════ */}
      <section className="wgbs-section" ref={wgbsRef}>
        <div className="container">
          <div className="wgbs-section__inner">
            <div className={`wgbs-section__content fade-in ${wgbsInView ? "visible" : ""}`}>
              <p className="wgbs-section__eyebrow">WE GIVE THE BEST SERVICES</p>
              <h2 className="wgbs-section__heading">
                Elevate Your Vehicle<br />
                <span className="wgbs-section__heading--accent">Beyond Expectations</span>
              </h2>
              <p className="wgbs-section__desc">{aboutDesc}</p>

              <div className="wgbs-section__checklist">
                <ul className="wgbs-section__list">
                  {wgbsCol1.map((svc, i) => (
                    <li key={svc.id || i} className="wgbs-section__list-item">
                      <span className="wgbs-section__check"><FiCheckCircle size={16} /></span>
                      <span>{svc.title}</span>
                    </li>
                  ))}
                </ul>
                <ul className="wgbs-section__list">
                  {wgbsCol2.map((svc, i) => (
                    <li key={svc.id || i} className="wgbs-section__list-item">
                      <span className="wgbs-section__check"><FiCheckCircle size={16} /></span>
                      <span>{svc.title}</span>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="wgbs-section__cta-row">
                <Link to="/contact" className="wgbs-section__cta-btn">Get in Touch with Us</Link>
                <div className="wgbs-section__stats">
                  <div className="wgbs-section__stat">
                    <strong>98%</strong><span>Client Satisfaction</span>
                  </div>
                  <div className="wgbs-section__stat-divider" />
                  <div className="wgbs-section__stat">
                    <strong>24/7</strong><span>Expert Support</span>
                  </div>
                </div>
              </div>
            </div>

            <div className={`wgbs-section__visual fade-in ${wgbsInView ? "visible" : ""}`} style={{ transitionDelay: "0.15s" }}>
              <div className="wgbs-section__badge wgbs-section__badge--above-img">
                <div className="wgbs-section__badge-icon">
                  <img src={carSvg} alt="Driving Quality" draggable="false" />
                </div>
                <div className="wgbs-section__badge-text">
                  <strong>Driving Quality</strong>
                  <span>Express Oil Change</span>
                </div>
              </div>

              <img
                src={aboutHero}
                alt="Automotive service team"
                className="wgbs-section__img"
                draggable="false"
                onDragStart={e => e.preventDefault()}
                onContextMenu={e => e.preventDefault()}
              />

              <div className="wgbs-section__badge wgbs-section__badge--br">
                <div className="wgbs-section__badge-icon">
                  <img src={repairSvg} alt="Quick Fix" draggable="false" />
                </div>
                <div className="wgbs-section__badge-text">
                  <strong>Quick Fix</strong>
                  <span>Tire Rotation</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* ═══════════════════════════════════════
    SHOP BY CAR BRAND
    ═══════════════════════════════════════ */}
    <section className="brand-section">
      <div className="container">
        <div className="brand-section__head">
          <p className="brand-section__eyebrow">SPARE PARTS BY VEHICLE</p>
          <h2 className="brand-section__title">Shop by Car Brand</h2>
          <div className="brand-section__title-bar" />
        </div>
        <div className="brand-section__body">
          <div className="brand-section__brands">
            <div className="brand-section__grid">
              {CAR_BRAND_PNG_LOGOS.map(brand => (
                <Link
                  key={brand.name}
                  to={`/shop?make=${encodeURIComponent(brand.name)}`}
                  className="brand-card"
                >
                  <div className="brand-card__logo">
                    <img src={brand.src} alt={brand.name} loading="lazy" draggable="false"
                      onDragStart={e => e.preventDefault()}
                      onContextMenu={e => e.preventDefault()} />
                  </div>
                  <span className="brand-card__name">{brand.name}</span>
                </Link>
              ))}
              <div className="brand-section__trust-card">
                <div className="home-best-svc__trust">
                  <div className="home-best-svc__trust-icon"><FiCheckCircle size={22} /></div>
                  <div className="home-best-svc__trust-text">
                    <strong>Trusted by Car Owners</strong>
                    <span>Quality repairs with guaranteed satisfaction – every time.</span>
                  </div>
                  <Link to="/shop" className="home-best-svc__trust-btn">
                    <FiArrowRight size={14} style={{ marginRight: 6 }} />BUY HERE
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div className="brand-section__video">
            <div className="brand-section__video-inner">
              <iframe
                  src="https://www.youtube.com/embed/0kZ3TZvYg10"
                  title="Noel Automotive Video"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
            </div>
          </div>
        </div>
      </div>
    </section>

      {/* ═══════════════════════════════════════
          WE OFFER BEST SERVICES
          ═══════════════════════════════════════ */}
      <section className="home-best-svc" ref={homeSvcSecRef}>
        <div className="container">
          <div className={`home-best-svc__head fade-in ${homeSvcSecInView ? "visible" : ""}`}>
            <p className="home-best-svc__label">OUR SERVICES</p>
            <h2 className="home-best-svc__title">We Offer Best Services</h2>
            <div className="home-best-svc__title-bar" />
          </div>

          <div className="home-best-svc__body">
            {!featured ? (
              <div className="home-best-svc__loading">Loading services…</div>
            ) : (
              <>
                <div className={`home-best-svc__featured fade-in ${homeSvcSecInView ? "visible" : ""}`} style={{ transitionDelay: "0.05s" }}>
                  <div className="home-best-svc__feat-img">
                    {resolveServiceImg(featured)
                      ? <img src={resolveServiceImg(featured)} alt={featured.title} loading="eager" draggable="false" onDragStart={e => e.preventDefault()} onContextMenu={e => e.preventDefault()} />
                      : <div className="home-best-svc__feat-no-img" />
                    }
                  </div>
                  <div className="home-best-svc__feat-body">
                    <h3 className="home-best-svc__feat-title">{featured.title}</h3>
                    <p className="home-best-svc__feat-desc">{wordLimit(stripHtmlText(featured.description), 40)}</p>
                    <ul className="home-best-svc__feat-bullets">
                      <li><FiCheckCircle size={16} /><span>Premium quality workmanship</span></li>
                      <li><FiCheckCircle size={16} /><span>Fast and reliable service</span></li>
                      <li><FiCheckCircle size={16} /><span>Customer satisfaction guaranteed</span></li>
                    </ul>
                    <Link to={`/services/${featured.slug}`} className="home-best-svc__feat-link">
                      View Details <FiArrowRight size={14} />
                    </Link>
                  </div>
                </div>

                <div className="home-best-svc__grid">
                  {gridItems.map((svc, i) => (
                    <div key={svc.id}
                      className={`home-best-svc__card fade-in ${homeSvcSecInView ? "visible" : ""}`}
                      style={{ transitionDelay: `${0.08 + i * 0.07}s` }}
                      onClick={() => setFeaturedSvcIdx(homeServices.indexOf(svc))}
                    >
                      <div className="home-best-svc__card-icon">
                        <img src={quickFixIcons[i % 6]} alt={svc.title} />
                      </div>
                      <h4 className="home-best-svc__card-title">{svc.title}</h4>
                      <p className="home-best-svc__card-desc">{wordLimit(stripHtmlText(svc.description), 18)}</p>
                      <Link to={`/services/${svc.slug}`} className="home-best-svc__card-link" onClick={e => e.stopPropagation()}>
                        <img src={quickFixIcons[i % 6]} alt="" className="home-best-svc__card-link-icon" />
                        View Details
                      </Link>
                    </div>
                  ))}

                  <div className="home-best-svc__trust">
                    <div className="home-best-svc__trust-icon"><FiCheckCircle size={22} /></div>
                    <div className="home-best-svc__trust-text">
                      <strong>Trusted by Car Owners</strong>
                      <span>Quality repairs with guaranteed satisfaction – every time.</span>
                    </div>
                    <Link to="/shop" className="home-best-svc__trust-btn">
                      <FiArrowRight size={14} style={{ marginRight: 6 }} />BUY HERE
                    </Link>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </section>

      {/* ═══════════════════════════════════════
          BEFORE & AFTER
          ═══════════════════════════════════════ */}
      <section className="bac-section" ref={bacRef}>
        <div className="container">
          <div className={`bac-section__head fade-in ${bacInView ? "visible" : ""}`}>
            <p className="bac-section__eyebrow">GET HELP &amp; BE TRANSFORMED</p>
            <div className="bac-section__title-bar" />
            <h2 className="bac-section__title">Spot the Difference</h2>
          </div>
          <div className={`bac-section__body fade-in ${bacInView ? "visible" : ""}`} style={{ transitionDelay: "0.1s" }}>
            <BeforeAfterSlider beforeSrc={beforeImg} afterSrc={afterImg} />
            <div className="bac-section__emergency">
              <h3 className="bac-section__emg-title">EMERGENCY<br />CAR REPAIR<br />SERVICES</h3>
              <div className="bac-section__emg-icon"><FiPhone size={36} /></div>
              {phoneNumber
                ? <a href={`tel:${phoneNumber.replace(/\s+/g, "")}`} className="bac-section__emg-number">{phoneNumber}</a>
                : <span className="bac-section__emg-number">Call Us Now</span>
              }
              <p className="bac-section__emg-sub">Fast response • 24/7</p>
              {phoneNumber && (
                <a href={`tel:${phoneNumber.replace(/\s+/g, "")}`} className="bac-section__emg-btn">Call Now →</a>
              )}
            </div>
          </div>
        </div>
      </section>

      {/* ═══════════════════════════════════════
          WHAT WE STOCK
          ═══════════════════════════════════════ */}
      <section className="products-section" ref={prodSecRef}>
        <div className="container">
          <div className={`products-section__head fade-in ${prodSecInView ? "visible" : ""}`}>
            <p className="products-section__eyebrow">WHAT WE STOCK</p>
            <h2 className="products-section__title">Browse Our Spare Parts</h2>
            <div className="products-section__title-bar" />
          </div>

          {productsLoading && <div className="products-section__skeleton" />}

          {!productsLoading && products.length > 0 && (
            <div className={`products-section__body fade-in ${prodSecInView ? "visible" : ""}`} style={{ transitionDelay: "0.1s" }}>
              <nav className="products-tabs" aria-label="Product categories">
                {products.map((prod, i) => (
                  <button key={prod.id}
                    className={`products-tab${activeProduct === i ? " products-tab--active" : ""}`}
                    onClick={() => setActiveProduct(i)} aria-selected={activeProduct === i}>
                    <div className="products-tab__icon-wrap">
                      <img src={PROD_ICONS[i % PROD_ICONS.length]} alt="" draggable="false" aria-hidden="true" />
                    </div>
                    <span className="products-tab__label">{prod.title}</span>
                  </button>
                ))}
              </nav>
              {activeProd && (
                <div className="products-panel">
                  <div className="products-panel__content">
                    <p className="products-panel__eyebrow">SPARE PARTS</p>
                    <h3 className="products-panel__title">{activeProd.title}</h3>
                    <p className="products-panel__desc">{activeProd.description ? wordLimit(stripHtmlText(activeProd.description), 45) : "Quality spare parts sourced and stocked to keep your vehicle running at its best."}</p>
                    <Link to="/shop" className="products-panel__btn">BUY SPARE PARTS <FiArrowRight size={14} /></Link>
                  </div>
                  <div className="products-panel__visual">
                    {CAR_BADGES.map((badge, bi) => (
                      <div key={bi} className={`products-panel__badge ${badge.cls}`} aria-hidden="true">
                        <div className="products-panel__badge-icon">
                          <img src={PROD_ICONS[badge.iconIdx % PROD_ICONS.length]} alt="" draggable="false" />
                        </div>
                        <span className="products-panel__badge-label">{badge.label}</span>
                      </div>
                    ))}
                    <img src={productsCar} alt="Car spare parts illustration" className="products-panel__car-img" draggable="false" onDragStart={e => e.preventDefault()} onContextMenu={e => e.preventDefault()} />
                  </div>
                </div>
              )}
            </div>
          )}

          {!productsLoading && products.length === 0 && (
            <div className={`products-section__body fade-in ${prodSecInView ? "visible" : ""}`} style={{ transitionDelay: "0.1s" }}>
              <nav className="products-tabs" aria-label="Product categories">
                {["Brakes", "Engine Parts", "Battery", "Windshield", "Disc & Rotor"].map((label, i) => (
                  <button key={i} className={`products-tab${activeProduct === i ? " products-tab--active" : ""}`}
                    onClick={() => setActiveProduct(i)} aria-selected={activeProduct === i}>
                    <div className="products-tab__icon-wrap">
                      <img src={PROD_ICONS[i % PROD_ICONS.length]} alt="" draggable="false" aria-hidden="true" />
                    </div>
                    <span className="products-tab__label">{label}</span>
                  </button>
                ))}
              </nav>
              <div className="products-panel">
                <div className="products-panel__content">
                  <p className="products-panel__eyebrow">SPARE PARTS</p>
                  <h3 className="products-panel__title">{["Brakes", "Engine Parts", "Battery", "Windshield", "Disc & Rotor"][activeProduct] || "Spare Parts"}</h3>
                  <p className="products-panel__desc">Quality spare parts sourced and stocked to keep your vehicle running at its best.</p>
                  <Link to="/shop" className="products-panel__btn">BUY SPARE PARTS <FiArrowRight size={14} /></Link>
                </div>
                <div className="products-panel__visual">
                  {CAR_BADGES.map((badge, bi) => (
                    <div key={bi} className={`products-panel__badge ${badge.cls}`} aria-hidden="true">
                      <div className="products-panel__badge-icon">
                        <img src={PROD_ICONS[badge.iconIdx % PROD_ICONS.length]} alt="" draggable="false" />
                      </div>
                      <span className="products-panel__badge-label">{badge.label}</span>
                    </div>
                  ))}
                  <img src={productsCar} alt="Car spare parts illustration" className="products-panel__car-img" draggable="false" onDragStart={e => e.preventDefault()} onContextMenu={e => e.preventDefault()} />
                </div>
              </div>
            </div>
          )}
        </div>
      </section>

      {/* ═══════════════════════════════════════
          OUR GALLERY
          ═══════════════════════════════════════ */}
      <section className="home-gallery-section" ref={galleryRef}>
        <div className="home-gallery__head-wrap">
          <div className={`home-gallery__head fade-in ${galleryInView ? "visible" : ""}`}>
            <div className="home-gallery__head-left">
              <p className="home-gallery__eyebrow">OUR WORK</p>
              <h2 className="home-gallery__title">Our Gallery</h2>
              <div className="home-gallery__title-bar" />
            </div>
            <div className="home-gallery__arrows">
              <button className="home-gallery__arrow" onClick={handleGalleryPrev} disabled={galleryIndex === 0} aria-label="Previous">
                <FiChevronLeft size={18} />
              </button>
              <button className="home-gallery__arrow" onClick={handleGalleryNext} disabled={galleryIndex >= galleryMaxIndex} aria-label="Next">
                <FiChevronRight size={18} />
              </button>
            </div>
          </div>
          <div className="home-gallery__divider" />
        </div>

        {galleryLoading ? (
          <div className="home-gallery__skeleton-row">
            {Array.from({ length: 5 }).map((_, i) => (
              <div key={i} className="home-gallery__skeleton-card" />
            ))}
          </div>
        ) : galleryImages.length === 0 ? (
          <p className="home-gallery__empty">No gallery images found.</p>
        ) : (
          <div className={`home-gallery__viewport fade-in ${galleryInView ? "visible" : ""}`} style={{ transitionDelay: "0.1s" }}>
            <div
              className="home-gallery__track"
              style={{ transform: `translateX(calc(-${galleryIndex} * (100vw / ${GALLERY_VISIBLE})))` }}
            >
              {galleryImages.map((img, i) => {
                const src = galleryImg(img.image_filename);
                return (
                  <div key={img.id} className="home-gallery__card" style={{ width: `calc(100vw / ${GALLERY_VISIBLE})` }}>
                    <div className="home-gallery__card-inner">
                      {src
                        ? <img src={src} alt={img.title || `Gallery image ${i + 1}`} loading="lazy" draggable="false" onDragStart={e => e.preventDefault()} onContextMenu={e => e.preventDefault()} />
                        : <div className="home-gallery__no-img" />
                      }
                      <div className="home-gallery__overlay">
                        <div className="home-gallery__plus"><FiPlus size={22} /></div>
                        {(img.title || img.description) && (
                          <div className="home-gallery__info">
                            {img.title && <span className="home-gallery__info-title">{img.title}</span>}
                            {img.description && <span className="home-gallery__info-desc">{img.description}</span>}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </section>

      {/* ═══════════════════════════════════════
          THE VEHICLES WE SPECIALISE ON
          ═══════════════════════════════════════ */}
      <section className="home-vehicles-section" ref={vehiclesRef}>
        <div className="home-vehicles__label-bar">
          <div className="container">
            <span className="home-vehicles__heading">THE VEHICLES WE SPECIALISE ON</span>
          </div>
        </div>
        <div className="home-vehicles__marquee">
          <div className="home-vehicles__track">
            {[...CAR_BRAND_LOGOS, ...CAR_BRAND_LOGOS].map((brand, i) => (
              <div key={i} className="home-vehicles__logo">
                <img
                  src={brand.src}
                  alt={brand.name}
                  title={brand.name}
                  loading="lazy"
                  draggable="false"
                  onDragStart={e => e.preventDefault()}
                  onContextMenu={e => e.preventDefault()}
                />
              </div>
            ))}
          </div>
        </div>
      </section>

    </main>
  );
}